import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { DateRenderer } from 'timeSheet/components/CellRenderers';

const useDateColumn = () => {
  const { t } = useContext(ConfigContext);

  const cellRenderer = useCallback((params) => {
    if (params.node?.group) return null;

    return DateRenderer({
      rowData: params.data
    });
  }, []);

  return useMemo(
    () => ({
      colId: 'visible-date',
      field: 'date',
      headerName: t('date'),
      cellClass: 'justify-start',
      width: 120,
      cellRenderer
    }),
    [t, cellRenderer]
  );
};

export default useDateColumn;
